import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { SplitInboundDeliveryMutation } from "../../../graphql/deliveryService/mutations/splitInboundDelivery";
import { InboundDeliverySplitOutputFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface SplitInboundDeliveryMutationProps {
  dataAction: (splitOutput: InboundDeliverySplitOutputFragment) => void;
  errorAction?: () => void;
}

const useSplitInboundDeliveryMutation = (
  props: SplitInboundDeliveryMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(SplitInboundDeliveryMutation, {
    update: (cache, result) => {
      const data = result.data?.splitInboundDelivery.inboundDeliverySplitOutput;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id: data.originalDelivery.id,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const inboundDeliverySplitOutput =
    data?.splitInboundDelivery.inboundDeliverySplitOutput;

  useEffect(() => {
    if (!error) return;

    handleError(t("splitInboundDeliveryError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !inboundDeliverySplitOutput) return;

    dataAction(inboundDeliverySplitOutput);
  }, [data]);

  return mutation;
};

export default useSplitInboundDeliveryMutation;
